/**
 * The signed-URL upload itself: PUT the bytes to storage with real byte-level progress.
 *
 * Its caller (ActionHost) owns the ticket, the finalize call and the cache, and reads the
 * progress while the bytes move. What a dataset accepts is decided by the dataset's kind and
 * lives in `~/utils/datasetKinds`; nothing here restates it, because a second accept list is a
 * second answer to the same question.
 */
export function useDatasetFileUpload() {
  const uploadProgress = ref(0);

  /** PUT the file to the signed URL with real byte-level progress via XHR. */
  function putWithProgress(url: string, file: File, contentType: string): Promise<void> {
    return new Promise((resolve, reject) => {
      const xhr = new XMLHttpRequest();
      xhr.open("PUT", url);
      xhr.setRequestHeader("Content-Type", contentType);
      xhr.upload.onprogress = (event) => {
        if (event.lengthComputable) {
          uploadProgress.value = Math.round((event.loaded / event.total) * 100);
        }
      };
      xhr.onload = () => {
        if (xhr.status >= 200 && xhr.status < 300) resolve();
        else reject(new Error(`Upload to storage failed (${xhr.status})`));
      };
      xhr.onerror = () => reject(new Error("Upload to storage failed (network error)"));
      xhr.send(file);
    });
  }

  return { uploadProgress, putWithProgress };
}
